import { Flex } from "@chakra-ui/layout";
import { Modal } from "antd";
import { useLoading } from "components/GlobalLoading";
import SelectTenantsComPermissao from "components/Input/SelectTenantsComPermissao";
import useDuplicarRelatorioPrestacaoContasTenants from "core/features/relatorios/prestacao-contas/hooks/useDuplicarRelatorioPrestacaoContasTenants";
import { PermissaoEnum } from "core/resources/enums/permissao";
import { showSuccess } from "infra/helpers/alerta";
import { useForm } from "react-hook-form";
import OutlineButton from "ui/components/Button/OutlineButton";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import Field from "ui/components/Input/Field";
import Toolbar from "ui/components/Toolbar";

interface ModalDuplicarTenantsProps {
  relatorioPrestacaoContasId: string;
  visible: boolean;
  onClose: () => any;
  refetch?: () => any;
}

function ModalDuplicarTenants({
  relatorioPrestacaoContasId,
  visible,
  onClose,
  refetch,
}: ModalDuplicarTenantsProps) {
  const { control, handleSubmit } = useForm<{
    tenantsIds: string[];
  }>({
    defaultValues: {
      tenantsIds: [],
    },
    mode: "all",
  });

  const { mutate: salvar, isLoading: isLoadingSave } =
    useDuplicarRelatorioPrestacaoContasTenants();

  const onSubmit = (form: { tenantsIds: string[] }) => {
    salvar(
      {
        id: relatorioPrestacaoContasId,
        tenantsIds: form.tenantsIds,
      },
      {
        onSuccess: () => {
          showSuccess("Relatório duplicado com sucesso").then(() => {
            refetch?.();
            onClose();
          });
        },
      }
    );
  };

  useLoading(isLoadingSave);
  return (
    <Modal
      destroyOnClose
      width={"500px"}
      closable={false}
      className="antd-custom-header"
      title={
        <Toolbar
          title="Duplicar relatório para outros condomínios"
          onClose={onClose}
          border="0px"
        />
      }
      centered
      footer={
        <Flex gridGap={4} justifyContent="flex-end">
          <OutlineButton onClick={onClose}>Fechar</OutlineButton>

          <PrimaryButton
            onClick={() => {
              handleSubmit(onSubmit)();
            }}
          >
            Duplicar
          </PrimaryButton>
        </Flex>
      }
      visible={visible}
      onCancel={onClose}
    >
      <Flex flexDir="column" gap={3}>
        <Field
          control={control}
          name={`tenantsIds`}
          label="Para quais condomínios?"
          render={({ field }) => (
            <SelectTenantsComPermissao
              mode="multiple"
              value={field.value}
              onChange={field.onChange}
              permissao={
                PermissaoEnum.Backoffice.Relatorios.Financeiro.PrestacaoContas
              }
            />
          )}
        />
      </Flex>
    </Modal>
  );
}

export default ModalDuplicarTenants;
